import {userConstants} from '../_constants';

export function statisticsOrder(state = {}, action) {
  switch (action.type) {
    case userConstants.STATISTICS_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.STATISTICS_ORDER_SUCCESS:
      return {
        ...state,
        data: [...action.data],
        loading: false,
      };
    case userConstants.STATISTICS_ORDER_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}